import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api
import { getListEvent } from '../../services/apis/EventAPIServices'

function* saga_LoadListEvent(action) {
    try {
        const { params } = action.payload

        let page_number = yield select(
            state => state.component_select_event.pageIndex
        )
        let page_size = yield select(
            state => state.component_select_event.pageSize
        )
        let status = yield select(state => state.component_select_event._status)
        let textSearch = yield select(
            state => state.component_select_event.lastTextSearch
        )

        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size
        if (params.status) status = params.status

        const response = yield call(
            getListEvent,
            page_number,
            page_size,
            status,
            textSearch
        )

        if (response.error.code === 200 || response.error.code === 309) {
            let events = response.data
            let total = response.total

            if (events.length > page_size) events = events.slice(0, page_size)

            yield put(actions.action.loadListEventSuccess(events))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                })
            )
        } else {
            console.error(
                '(Component) Get list event API server error ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('(Component) Load list event error : ', ex.message)
    }
}

function* saga_ChangePageSize(action) {
    try {
        const { pageSize } = action.payload

        yield put(actions.action.loadListEvents({ page_size: pageSize }))
    } catch (ex) {
        console.log('(Component) Change page event size error : ', ex.message)
    }
}

function* saga_ChangeCurrentPage(action) {
    try {
        const { pageIndex } = action.payload

        yield put(actions.action.loadListEvents({ page_number: pageIndex }))
    } catch (ex) {
        console.log(
            '(Component) Change current event page error : ',
            ex.message
        )
    }
}

function* saga_SearchEvent() {
    try {
        let page_number = yield select(
            state => state.component_select_event.pageIndex
        )
        let page_size = yield select(
            state => state.component_select_event.pageSize
        )
        let status = yield select(state => state.component_select_event._status)
        let textSearch = yield select(
            state => state.component_select_event.textSearch
        )

        const response = yield call(
            getListEvent,
            page_number,
            page_size,
            status,
            textSearch
        )

        if (response.error.code === 200) {
            let events = response.data
            let total = response.total

            if (events.length > page_size) events = events.slice(0, page_size)

            yield put(actions.action.loadListEventSuccess(events))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                })
            )
        } else {
            console.error(
                '(Component) Get search list event API server error ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('(Component) Load search list event error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.LOAD_LIST_EVENTS, saga_LoadListEvent)
    yield takeEvery(actions.type.CHANGE_CURRENT_PAGE, saga_ChangeCurrentPage)
    yield takeEvery(actions.type.CHANGE_PAGE_SIZE, saga_ChangePageSize)
    yield takeEvery(actions.type.SEARCH_EVENT, saga_SearchEvent)
}

export default function* componentSelectEventSaga() {
    yield all([fork(listen)])
}
